import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const HomeEventsSkeleton = () => {
    return (
        <Flexbox direction="column" gap={2}>
            {Array.from({length: 3}).map((_, index) => (
                <Flexbox key={index} align="center" gap={2}>
                    <Flexbox align="center" gap={2} style={{minWidth: '95px'}}>
                        <Skeleton width={16} height={16} />
                        <Skeleton width={100} height={16} />
                    </Flexbox>
                    <Flexbox align="center" gap={3}>
                        <Skeleton width={150} height={16} />
                        <Skeleton width={100} height={16} />
                    </Flexbox>
                </Flexbox>
            ))}
        </Flexbox>
    )
}
